import { Box } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

export const CardItemWrapper = styled(Box)<{ $isMobile?: boolean; $isFlipDisabled?: boolean }>`
  width: ${({ $isMobile }) => ($isMobile ? '100%' : '480px')};
  position: relative;

  ${({ $isFlipDisabled }) => $isFlipDisabled && css`
    pointer-events: none;
  `}
`;

export const CardLoggedTooltip = styled(Box)`
  position: absolute;
  width: 100%;
  z-index: 100;
  top: -19px;
`;

interface CardStatusActionWrapProps {
  $width?: string;
  $height?: string;
  $isCompact?: boolean;
  $isMobile?: boolean;
  $withBorderShadow?: boolean;
}

export const CardStatusActionWrap = styled(Box)<CardStatusActionWrapProps>`
  ${({ $isMobile, $height, $width, $isCompact, theme }) => {
    if ($isMobile) {
      return css`
        width: 100%;
        padding: ${theme.spacings.spacing12} ${theme.spacings.spacing16};
      `;
    }
    return css`
      height: ${$height || '252px'};
      width: ${$width || '300px'};
      padding: ${$isCompact ? theme.spacings.spacing24 : `${theme.spacings.spacing32} ${theme.spacings.spacing24}`};
    `;
  }}

  ${({ $withBorderShadow, theme }) => $withBorderShadow && css`
    box-shadow: inset 0 0 0 1px ${theme.colors.border2};
  `}
`;
